import { unitMapping, type Unit } from '#src/lib/style.ts';

import type { IconColor } from './useIconColor.tsx';
import { useIconColor } from './useIconColor.tsx';

type Props = {
  size?: Unit;
  color?: IconColor;
};

export const Quickplay = ({ size = 3, color }: Props) => {
  const { fill } = useIconColor(color);

  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 7L10 0H8L2 7V9H7L6 16H8L14 9L14 7H9Z" fill={fill} />
    </svg>
  );
};
